var React = require('react');

function TriangleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.7528 21.6218C28.8589 20.8235 28.8589 19.1765 27.7528 18.3782L3.17041 0.637413C1.84768 -0.317184 0 0.627964 0 2.25918L0 37.7408C0 39.372 1.84768 40.3172 3.17041 39.3626L27.7528 21.6218Z","fill":"#FAFCFD"}));
}

TriangleInline.defaultProps = {"width":"29","height":"40","viewBox":"0 0 29 40","fill":"none"};

module.exports = TriangleInline;

TriangleInline.default = TriangleInline;
